import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useStateIfMounted from '../hook/useStateIfMounted';
import ExpenseContext from '../contexts/expense-context';
import Loading from '../common/Loading';
import ExpenseDescription from './ExpenseDesription';
import ExpenseTypeAndPeriod from './ExpenseTypeAndPeriod';
import ExpenseCurrency from './ExpenseCurrency';
import ExpenseVendorInvoice from './ExpenseVendorInvoice';
import ExpensePolicy from './ExpensePolicy';
import ExpenseAccount from './ExpenseAccount';
import ExpenseAmount from './ExpenseAmount';
import ExpenseArrangement from './ExpenseArrangement';
import ExpenseInstallments from './ExpenseInstallments';
import { selectValue } from '../common/comops';
import { detail } from '../apis/expense';
import businessKeys from '../constants/businessKeys';
import { Period } from '../common/Period';
import { setPeriods } from '../main/duck/actions';

const setExchangeRate = (rate) => {
    const element = document.querySelector(`#${businessKeys.EXPENSE_EXCHANGE_RATE}`);
    if (element)
        element.value = rate.toString();
}

const sanitizeCloneExpenseData = (source) => {
    const installments = (source.installments || []).map(item => ({
        ...item,
        id: 0,
        masterId: 0,
        paymentId: null,
        sourceId: null,
        ispaid: false
    }));

    return {
        ...source,
        id: 0,
        installments
    };
}

const CreateExpense = props => {

    const refPrice = useRef();
    const [loading, setLoading] = useState(false);
    const [account, setAccount] = useState(undefined);
    const [policy, setPolicy] = useState(undefined);
    const [arrangement, setArrangement] = useState(new Date());
    const [dueDate, setDueDate] = useState(undefined);
    const [currency, setCurrency] = useState({});
    const [getData, setGetData] = useState(true);
    const [data, setData] = useStateIfMounted({ installments: [] });
    const [vendor, setVendor] = useState(undefined);
    const [expenseType, setExpenseType] = useState({});
    const [taxRate, setTaxRate] = useState({ value: 0, label: "0%" });
    const [updating, setUpdating] = useState(false);
    const [activeInstallment, setActiveInstallment] = useState(-1);
    const [genel, setGenel] = useState(false);
    const [singlePeriod, setSinglePeriod] = useState(false);
    const [user, setUser] = useState({});
    const [notes, setNotes] = useState('');
    const currencies = useSelector(state => state.main.currencies);
    const expenseTypes = useSelector(state => state.main.expenseTypes);
    const dispatch = useDispatch();
    const copyFromId = new URLSearchParams((props.location || {}).search || "").get("copyFrom");
    const currentExpenseId = props.expenseId || 0;
    const loadExpenseId = currentExpenseId || (copyFromId ? parseInt(copyFromId) : 0);
    const isCopyMode = !currentExpenseId && !!copyFromId;

    useEffect(() => {
        if (!getData || !loadExpenseId) {
            if (getData)
                setGetData(false);
            return;
        };
        setLoading(true);
        setGetData(false);
        detail(loadExpenseId).then(result => {
            const sourceData = result.data || {};
            const activeData = isCopyMode ? sanitizeCloneExpenseData(sourceData) : sourceData;

            setData(activeData);
            if (activeData.dueDate)
                setDueDate(new Date(activeData.dueDate));
            if (activeData.arrangementDate)
                setArrangement(new Date(activeData.arrangementDate));
            setCurrency(activeData.currencyId);

            setTaxRate(activeData.taxRate || 0);
            setGenel(activeData.genel || false);
            setNotes(activeData.notes || '');
            setUser(activeData.accountManagerId)
            setSinglePeriod({ value: activeData.expensePeriod, label: activeData.expensePeriod });
            const expenseTypeId = (activeData || {}).expenseTypeId;
            if (expenseTypeId) {
                const exType = expenseTypes.find(ex => ex.value === expenseTypeId);
                setExpenseType(exType);
            }

            const accountId = (activeData || {}).accountId;
            if (accountId) {
                setAccount({ value: accountId, label: activeData.accountName });
            }
            const vendorId = (activeData || {}).vendorId;
            if (vendorId) {
                setVendor({ value: vendorId, label: activeData.vendor });
            }

            const policyId = (activeData || {}).policyId;
            if (policyId) {
                setPolicy({ value: policyId, label: activeData.policy });
            }
        }).finally(() => {
            setLoading(false);
        });
    }, [, getData]);

    useEffect(() => {
        if (!expenseType || !expenseType.stringHelper2) {
            dispatch(setPeriods([]));
            setSinglePeriod(null);
            return;
        }
        const types = expenseType.stringHelper2.split(';');
        const per = types.flatMap(item => Period.getPeriods(new Date().getFullYear(), +item)).sort().reverse();
        dispatch(setPeriods(per));
    }, [expenseType])

    useEffect(() => {
        // Eğer currency değişirse ona gore atiyor.
        if (currency && (data.currency !== selectValue(currency) || !data.exchangeRate) && currency.decimalHelper) {
            setExchangeRate(currency.decimalHelper);
        } else if (data.exchangeRate) {
            setExchangeRate(data.exchangeRate);
        }
    }, [currency]);

    useEffect(() => {
        if (!selectValue(policy))
            return;
        if (!selectValue(account))
            setAccount({ value: policy.intHelper4, label: policy.stringHelper })
        if (!selectValue(currency)) {
            const selectedCurrency = currencies.find(item => item.value === policy.intHelper);
            setCurrency(selectedCurrency);
        }
        if (!selectValue(user))
            setUser(policy.intHelper3)

    }, [policy])

    return (<ExpenseContext.Provider value={{
        data, loading, account, policy,
        arrangement, currency, setCurrency, getData, setGetData, vendor, setVendor, expenseType, setExpenseType,
        expenseId: currentExpenseId, setPolicy, setAccount, taxRate, setTaxRate, setArrangement, dueDate, setDueDate, refPrice,
        updating, setUpdating, setData, activeInstallment, setActiveInstallment, genel, setGenel, user, setUser, singlePeriod, setSinglePeriod, notes, setNotes
    }}>
        <div className="create-expense">
            {loading ? <Loading className="big" /> : <>
                <div className="expense-general">
                    <ExpenseDescription />
                    <ExpenseTypeAndPeriod />
                    <ExpenseVendorInvoice />
                    <ExpenseCurrency />
                    <ExpensePolicy />
                    <ExpenseAccount />
                    <ExpenseArrangement />
                    <ExpenseAmount ref={refPrice} />
                    {/*  <ExpenseDue /> */}
                    <ExpenseInstallments />
                </div>
            </>}
        </div>
    </ExpenseContext.Provider>
    )
}


export default CreateExpense;